import React from 'react';
import { connect } from 'react-redux';
import { Tree } from 'antd';

import { getActivityTypesForFilters, getZoneFromData } from 'helpers/agendaHelpers';

import styles from '../Calendar/styles.module.scss';

const { TreeNode } = Tree;

export const Filters = ({ onChange, activityTypes, data }) => (
  <div className={styles.filters}>
    <div>
      <h3 className={styles.filters__title}>Forêts</h3>
      <Tree
        key={getZoneFromData(data).sort().join('')} // add a key to prevent AntDesign error
        checkable
        selectable={false}
        defaultCheckedKeys={['all']}
        onCheck={value => onChange({ zones: value })}
      >
        <TreeNode title="Toutes les forêts" key="all">
          {getZoneFromData(data).map(zone => (
            <TreeNode key={zone} className={styles.filters__capitalize} title={zone} />
          ))}
        </TreeNode>
      </Tree>
    </div>
    <div>
      <h3 className={styles.filters__title}>Type d'activités</h3>
      <Tree
        checkable
        selectable={false}
        defaultCheckedKeys={['all']}
        onCheck={value => onChange({ activities: value })}
      >
        <TreeNode title="Tout type d'activités" key="all">
          {getActivityTypesForFilters(activityTypes).map(
            ({ categoryLabel, category, children }) => (
              <TreeNode title={categoryLabel} key={category}>
                {children.map(({ label, value }) => <TreeNode title={label} key={`${category},${value}`} />)}
              </TreeNode>
            ),
          )}
        </TreeNode>
      </Tree>
    </div>
    <div>
      <h3 className={styles.filters__title}>Statuts</h3>
      <Tree
        checkable
        selectable={false}
        defaultCheckedKeys={['all']}
        onCheck={value => onChange({ status: value })}
      >
        <TreeNode title="Tous les statuts" key="all">
          <TreeNode title="Accepté" key={300} />
          <TreeNode title="En cours d'évaluation" key={200} />
        </TreeNode>
      </Tree>
    </div>
  </div>
);

const mapStateToProps = ({ admin: { activities: { list } } }) => ({
  activityTypes: list,
});

export default connect(mapStateToProps)(Filters);



// WEBPACK FOOTER //
// ./src/components/Agenda/Filters/index.js